// material-ui
import {
  Avatar,
  Box,
  ButtonBase,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  useTheme,
} from "@mui/material";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import LogoutIcon from "@mui/icons-material/Logout";
// project imports
import LogoSection from "./logo/index";
import { useNavigate } from "react-router-dom";
import ROUTE_NAMES from "routes/routeNames";
import React from "react";
import { logoutManually } from "modules/auth/action";
import { useDispatch } from "react-redux";

function Header() {
  const navigate = useNavigate();
  const dispatch: Function = useDispatch();
  const theme: any = useTheme();
  // code for profile functionality and logout
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const LogoutHandler = () => {
    dispatch(
      logoutManually((response: any) => {
        if (response.isSuccess) {
          sessionStorage.clear();
          navigate("/");
        }
      })
    );
    handleClose();
  };

  const onNotificationClick = () => {
    // navigate(ROUTE_NAMES.MAIN_ROUTES.NOTIFICATIONS_MANAGEMENT);
    navigate(ROUTE_NAMES.MAIN_ROUTES.DASHBOARD);
  };

  const renderNotificationIcon = () => (
    <ButtonBase sx={{ borderRadius: "12px" }} onClick={onNotificationClick}>
      <Avatar
        variant="rounded"
        sx={{
          ...theme.typography.commonAvatar,
          ...theme.typography.mediumAvatar,
          transition: "all .2s ease-in-out",
          background: theme.palette.secondary.light,
          color: theme.palette.secondary.dark,
          '&[aria-controls="menu-list-grow"],&:hover': {
            background: theme.palette.secondary.dark,
            color: theme.palette.secondary.light,
          },
        }}
        aria-haspopup="true"
        color="inherit"
      >
        <NotificationsOutlinedIcon />
      </Avatar>
    </ButtonBase>
  );

  return (
    <>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          padding: "16px 0px",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            width: 228,
            display: "flex",
            paddingTop: "5px",
          }}
        >
          <LogoSection />
        </Box>
        <Box sx={{ flexGrow: 1 }} />
        <Box
          sx={{
            mr: 3,
            mt: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            // border:"1px solid black"
          }}
        >
          {/* notification & profile */}
          {/* {renderNotificationIcon()} */}

          {/* Admin Profile Icon */}
          <IconButton onClick={handleClick}>
            <AccountCircleIcon style={{ width: 32, height: 32 }} />
            <ExpandMoreIcon style={{ width: 22, height: 22 }} />
          </IconButton>
          {/* Logout Button */}
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            sx={{
              "& .MuiList-root": {
                p: "8px",
              },
              "& .MuiMenuItem-root": {
                px: "1rem,",
                borderRadius: "6px",
                display: "flex",
                gap: "1rem",
              },
            }}
          >
            <MenuItem onClick={LogoutHandler}>
              <ListItemText>{"Logout"}</ListItemText>
              <ListItemIcon>
                <LogoutIcon />
              </ListItemIcon>
            </MenuItem>
          </Menu>
        </Box>
      </Box>
    </>
  );
}

export default Header;
